module.exports = __webpack_public_path__ + "img/img32.df8ec705.jpg";